import { Button } from "@/shared/ui/button";
import { Calendar } from "@/shared/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shared/ui/popover";
import { CalendarIcon, X } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { DateRange } from "react-day-picker";
import { cn } from "@/shared/lib/utils";

interface DateRangePickerProps {
  dateRange: DateRange | undefined;
  setDateRange: (range: DateRange | undefined) => void;
  placeholder?: string;
  className?: string;
}

export function DateRangePicker({ dateRange, setDateRange, placeholder = "Selecione um período", className }: DateRangePickerProps) {
  const handleClearDates = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDateRange(undefined);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className={cn("w-full justify-start text-left font-normal bg-[#1A1A1A] text-white/90 border-white/[0.06]", className)}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {dateRange?.from ? (
            dateRange.to ? (
              <div className="flex items-center gap-1">
                <span>{format(dateRange.from, "dd/MM/yyyy", { locale: ptBR })}</span>
                <span> - </span>
                <span>{format(dateRange.to, "dd/MM/yyyy", { locale: ptBR })}</span>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={handleClearDates}
                  className="h-7 ml-1 text-xs"
                >
                  <X className="h-4 w-4 text-red-500" />
                </Button>
              </div>
            ) : (
              <span>{format(dateRange.from, "dd/MM/yyyy", { locale: ptBR })} - ...</span>
            )
          ) : (
            <span>{placeholder}</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#1A1A1A] text-white/90 border-white/[0.06]">
        <Calendar
          mode="range"
          selected={dateRange}
          onSelect={setDateRange}
          numberOfMonths={1}
          locale={ptBR}
          showOutsideDays={false}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
